import * as React from 'react';
import { injectIntl, InjectedIntlProps } from 'react-intl';
import { withRouter, RouteComponentProps } from 'react-router';
import { compose } from 'redux';
import { Drawer, Checkbox } from 'components/';
import * as Queries from 'api/graphql/queries';
import { OrderDirection, adminCmsList } from '@api/graphql/types';
import GraphQLClient from '@api/graphql/GraphQLClient';
import ControlledTable from '@components/ControlledTable';
import { RowInfo } from 'react-table';
import { Column } from 'react-virtualized';
import { Paths } from '..';
import { BooleanCell, OpenInNewCell } from '@components/Table/Cell';
import { DispatchProp, connect } from 'react-redux';
import { updateListOptions } from '@actions/listActions';
import { ListOptionType } from '@reducers/listReducer';
import { ApplicationState } from 'reducers/';

interface StateType {
    data: any[];
    paginatorInfo: any;
    shouldFilterActive: boolean;
}

export interface UserFilterType {
    id: string;
    ext_id: string;
    name: string;
    email: string;
}

const CmsListDefaultOptions = {
    sortBy: {
        field: 'id',
        direction: OrderDirection.DESC,
    },
    count: 10,
    page: 0,
    filters: {
    },
};

const listName = 'cmsList';

interface ReduxProps {
    listOptions: ListOptionType;
}

type Props = ReduxProps & DispatchProp & InjectedIntlProps & RouteComponentProps;

class CmsList extends React.Component<Props, StateType> {

    public state = {
        data: [],
        paginatorInfo: {},
        shouldFilterActive: true,
    };

    private OpenCell = OpenInNewCell((rowInfo: any) => {
        return `${Paths.cms}/${rowInfo.original.id}`;
    });

    private tableColumns = [
        {Header: '', sortable: false, Cell: this.OpenCell, width: 30},
        this.getDefaultColumnByName('id', {sortable: true}),
        this.getDefaultColumnByName('title', {sortable: true}),
        this.getDefaultColumnByName('url_key', {sortable: true}),
        this.getDefaultColumnByName('is_active', {sortable: true, Cell: BooleanCell}),
        this.getDefaultColumnByName('active_from', {sortable: true}),
        this.getDefaultColumnByName('active_to', {sortable: true}),
    ];

    public componentDidMount() {
        this.fetchData();
    }

    public componentDidUpdate(prevProps: Props) {
        if (prevProps.listOptions !== this.props.listOptions) {
            this.fetchData();
        }
    }

    private getDefaultColumnByName(name: string, options: any = {}) {
        return {
            Header: this.label(`${name}.title`),
            accessor: name,
            sortable: false,
            ...options,
        };
    }

    private label(id: string): string {
        return this.props.intl.formatMessage({ id: `module.cms.${id}` });
    }

    private getFilters() {
        const result = {...this.props.listOptions.filters};
        Object.keys(result).forEach((key) => !result[key] && delete result[key]);
        result.is_active = this.state.shouldFilterActive || undefined;
        return result;
    }

    private getSortBy() {
        return {
            field: this.props.listOptions.sortBy.field.toUpperCase(),
            direction: this.props.listOptions.sortBy.direction.toUpperCase(),
        };
    }

    private fetchData() {
        const variables = {...this.props.listOptions, page: this.props.listOptions.page + 1, sortBy: this.getSortBy(), filters: this.getFilters()};
        GraphQLClient.query<adminCmsList>({
            query: Queries.adminCmsContents,
            variables,
        }).then(response => {
            const data = response.data.adminCmsContents ? response.data.adminCmsContents.data : [];
            const paginatorInfo = response.data.adminCmsContents ? response.data.adminCmsContents.paginatorInfo : {};
            this.setState({data, paginatorInfo});
        });
    }

    private onOptionsChange = (options: ListOptionType) => {
        this.props.dispatch(updateListOptions(listName, options));
    }

    private onRowClick = (finalState: any, rowInfo?: RowInfo, column?: Column, instance?: any): object | undefined => {
        if (rowInfo) {
            return {
                onClick: () => {
                    this.props.history.push(`${Paths.cms}/${rowInfo.original.id}`);
                },
                style: {
                    cursor: 'pointer',
                },
            };
        }
        return {};
    }


    public render() {
        const addButton = <button className="btn btn-primary" onClick={(e: React.SyntheticEvent) => this.props.history.push(Paths.cmsCreate)}>Új cikk</button>;

        return (
            <Drawer headerButton={addButton}>
                <div className="row">
                    <div className="col-lg-12">
                        <div className="ibox float-e-margins">
                            <div className="ibox-content">
                                <Checkbox
                                    checked={this.state.shouldFilterActive}
                                    label={this.props.intl.formatMessage({id: 'common.filterActive'})}
                                    onChange={(e: React.ChangeEvent<any>) => {
                                        this.setState({ shouldFilterActive: e.currentTarget.checked }, () => this.fetchData());
                                    }}
                                />
                                <ControlledTable
                                    listName={listName}
                                    defaultOptions={CmsListDefaultOptions}
                                    columns={this.tableColumns}
                                    options={this.props.listOptions}
                                    data={this.state.data}
                                    paginatorInfo={this.state.paginatorInfo}
                                    onOptionsChange={this.onOptionsChange}
                                    onRowClick={this.onRowClick}
                                />
                            </div>
                        </div>
                    </div>
                </div>
            </Drawer>
        );
    }
}

const mapStateToProps = ({ lists }: ApplicationState): ReduxProps => {
    return { listOptions: (lists ? (lists[listName] || CmsListDefaultOptions) : CmsListDefaultOptions) };
};

export default compose(
    withRouter,
    injectIntl,
    connect(mapStateToProps),
)(CmsList);



// WEBPACK FOOTER //
// ./src/modules/Cms/pages/CmsList.tsx